<app-page>
    <app-campaign [campaignId]="campaignId"></app-campaign>
</app-page>
